import { render, staticRenderFns } from "./ProductListHeader.vue?vue&type=template&id=15c608a5&scoped=true&"
import script from "./ProductListHeader.vue?vue&type=script&lang=js&"
export * from "./ProductListHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProductListHeader.vue?vue&type=style&index=0&id=15c608a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c608a5",
  null
  
)

export default component.exports